import LoginForm from "../../components/UserManagement/LoginForm";

export default function Login() {
  return <LoginForm />;
}
